import { render, staticRenderFns } from "./inputFile.vue?vue&type=template&id=2b169dda"
import script from "./inputFile.vue?vue&type=script&lang=ts"
export * from "./inputFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports